import OwnersFilter from "components/filters/Filters/OwnersFilter";
import React from "react";

const Filters = () => {
  return <>
    <OwnersFilter />
  </>;
};

export default Filters;